export default "__VITE_ASSET__DgjgESiU__"